import { Button, Stack, Tooltip } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

export interface WidgetSummaryFooterProps {
  isValid: boolean;
  onSaveAndClose: () => void;
  onSave: () => void;
  saveInProgress: boolean;
  mode: 'edit' | 'create';
}

export const WidgetSummaryFooter = ({
  onSave,
  onSaveAndClose,
  saveInProgress,
  mode,
  isValid,
}: WidgetSummaryFooterProps): JSX.Element => {
  const { t } = useTranslation('feedback');
  return (
    <>
      {mode === 'create' && (
        <Tooltip isDisabled={isValid} text={t('feedback-wizard.summary.review-errors-tooltip')}>
          <span>
            <Button
              kind="primary"
              size="m"
              onClick={() => onSaveAndClose()}
              loadingText={t('feedback-wizard.summary.save-in-progress')}
              isLoading={saveInProgress}
              isDisabled={!isValid}
            >
              {t('feedback-wizard.summary.create-widget')}
            </Button>
          </span>
        </Tooltip>
      )}
      {mode === 'edit' && (
        <Stack direction="row" spacing="x2">
          <Tooltip isDisabled={isValid} text={t('feedback-wizard.summary.review-errors-tooltip')}>
            <span>
              <Button
                kind="primary"
                size="m"
                onClick={() => onSave()}
                loadingText={t('feedback-wizard.summary.save-in-progress')}
                isLoading={saveInProgress}
                isDisabled={!isValid}
              >
                {t('feedback-wizard.summary.update-widget')}
              </Button>
            </span>
          </Tooltip>
          <Tooltip isDisabled={isValid} text={t('feedback-wizard.summary.review-errors-tooltip')}>
            <span>
              <Button
                kind="secondary"
                size="m"
                onClick={() => onSaveAndClose()}
                loadingText={t('feedback-wizard.summary.save-in-progress')}
                isLoading={saveInProgress}
                isDisabled={!isValid}
              >
                {t('feedback-wizard.summary.update-widget-and-close')}
              </Button>
            </span>
          </Tooltip>
        </Stack>
      )}
    </>
  );
};
